<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Autenticación de dos factores</h3>
      </div>
    </div>
    <div class="layout__main-form">
      <div class="card">
        <div class="card__content">
          <div class="row center-xs">
            <div class="col-xs-12">
              <p>Se ha enviado el código de verificación al correo: {{ email_enmascarado }}</p>
              <div class="card__content">
                <div class="row center-xs">
                  <div class="col-xs-12 col-md-4">
                    <input-field v-model="form.codigo_verificacion" v-mask="'######'" type="tel" id="codigo_verificacion" ref="codigo_verificacion" placeholder="Ingrese código de verificación..." autofocus/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-buttons">
          <div class="row center-xs">
            <div class="col-md-3">
              <button :disabled="bloquear_reenvio_codigo" :tooltip="bloquear_reenvio_codigo?'Debe esperar 10 min. para poder re-enviar de nuevo.':null" @click="reenviarCodigoVerificacion()" type="button" class="btn-primary btn--bigger">
                <i class="fa fa-refresh"></i>
                <span>Re-enviar código de verificación</span>
              </button>
            </div>
            <div class="col-md-3">
              <button @keyup.enter="aceptar()" @click="aceptar()" :tooltip="bloquear_verificar_codigo?'Debe esperar 10 min. para poder verificar de nuevo.':null" :disabled="!tieneCodigoVerificacion || (tieneCodigoVerificacion && bloquear_verificar_codigo)" type="button" class="btn-success btn--bigger">
                <i class="fa fa-check"></i>
                <span>Verificar</span>
              </button>
            </div>
            <div class="col-md-3">
              <div :class="claseNotification()">
                <i class="fa fa-clock-o"></i>
                <span> Vigencia de código: <strong>{{ this.tiempo_vigencia }}</strong></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    propUsuarioId: {
      type: String,
      required: true,
    },
    propEmail: {
      type: String,
      required: true,
    },
    propPassword: {
      type: String,
      required: true,
    },
    csrToken: {
      type: String,
      required: true,
    },
    propBloquearReenvioCodigo: {
      type: Boolean,
      required: true,
    },
    propBloquearVerificarCodigo: {
      type: Boolean,
      required: true,
    },
    propFechaExpiracion: {
      type: String,
      required: true,
      default: function(){
        return null;
      }
    },
  },
  data() {
    return {
      interval_reenvio_id: null,
      interval_verificar_id: null,
      interval_tiempo_vigencia_id: null,
      email_enmascarado: '',
      bloquear_reenvio_codigo: false,
      bloquear_verificar_codigo: false,
      fecha_expiracion: this.propFechaExpiracion,
      tiempo_vigencia: '',
      form: {
        usuario_id: this.propUsuarioId,
        email: this.propEmail,
        codigo_verificacion: '',
        password: this.propPassword,
      }
    }
  },
  watch: {
    'bloquear_reenvio_codigo': async function(){
      if(this.bloquear_reenvio_codigo)
        await this.verificarDesbloqueoReenvio();
      else if(!this.bloquear_reenvio_codigo && this.interval_reenvio_id != null){
        clearInterval(this.interval_reenvio_id);
        this.interval_reenvio_id = null;
      }
    },
    'bloquear_verificar_codigo': async function(){
      if(this.bloquear_verificar_codigo)
        await this.verificarCodigoDesbloqueo();
      else if(!this.bloquear_verificar_codigo && this.interval_verificar_id != null){
        clearInterval(this.interval_verificar_id);
        this.interval_verificar_id = null;
      }
    },
  },
  computed: {
    tieneCodigoVerificacion: function () {
      return (this.form.codigo_verificacion != '' && this.form.codigo_verificacion != null) && this.form.codigo_verificacion.length == 6;
    }
  },
  mounted() {
    this.email_enmascarado = this.form.email.replace(/^(.)(.*)(.@.*)$/, (str, a, b, c) => a + b.replace(/./g, '*') + c);
    this.$refs.codigo_verificacion.$el.firstChild.focus();
    this.bloquear_reenvio_codigo = this.propBloquearReenvioCodigo;
    this.bloquear_verificar_codigo = this.propBloquearVerificarCodigo;
    if(this.fecha_expiracion != null && this.fecha_expiracion != '')
      this.cuentaRegresiva();
  },
  methods: {
    verificarCodigoDesbloqueo: async function(){
      this.interval_verificar_id = setInterval(() => {
        fetch(`${url}/codigo-verificacion/verificar-codigo-desbloqueo/${this.form.usuario_id}`)
          .then((response) => response.json())
          .then((data) => {
          this.bloquear_verificar_codigo = data.bloquearVerificarCodigo;
        }).catch(console.error);
      }, 5000);
    },
    verificarDesbloqueoReenvio: async function(){
      this.interval_reenvio_id = setInterval(() => {
        fetch(`${url}/codigo-verificacion/verificar-desbloqueo-reenvio/${this.form.usuario_id}`)
          .then((response) => response.json())
          .then((data) => {
          this.bloquear_reenvio_codigo = data.bloquearReenvioCodigo;
        }).catch(console.error);
      }, 5000);
    },
    redirect: function(url, method, paramas) {
      let form = document.createElement('form');
      form.id = 'formulario'
      form.method = method;
      form.action = url;
      for (const key in paramas) {
        let input = document.createElement('input');
        input.type = 'text';
        input.hidden = true;
        input.name = key;
        input.value = paramas[key];
        form.appendChild(input);
      }
      let input2 = document.createElement('input');
      input2.type = 'hidden';
      input2.name = '_token';
      input2.value = this.csrToken;
      form.appendChild(input2);
      document.body.appendChild(form);
      form.submit();
      document.getElementById('formulario').remove();
    },
    aceptar: function(){
      if(!this.tieneCodigoVerificacion)
        return;
      axios.post(url+ '/codigo-verificacion/verificar-codigo', this.form).then(response => {
        let data = response.data;
        if(data.error){
          if(data.bloquearVerificarCodigo)
            this.bloquear_verificar_codigo = data.bloquearVerificarCodigo;
          swal.fire('Aviso', data.mensaje, 'warning');
        }
        else{
          swal.fire('Autenticado', 'Se ha autenticado con exito.', 'success');
          this.redirect(url+ '/login', 'POST', this.form);
        }
      }).catch(error => {
        console.log(error);
        if(error !== undefined && error !== null){
          let response = error.response;
          console.log(response);
        }
        swal.fire('Hubo un error, intente nuevamente.', 'Error', 'error');
      });
    },
    reenviarCodigoVerificacion: async function(){
      if(this.bloquear_reenvio_codigo)
        return;
      await axios.post(url+ '/codigo-verificacion/reenviar-codigo-verificacion', this.form).then(response => {
        let data = response.data;
        if(data.error)
          swal.fire('Aviso', data.mensaje, 'warning');
        this.bloquear_reenvio_codigo = data.bloquearReenvioCodigo;
        this.fecha_expiracion = data.fechaExpiracion;
        swal.fire('Enviado', 'Se ha re-enviado el código de verificación al correo.', 'success');
      }).catch(error => {
        console.log(error);
        if(error !== undefined && error !== null){
          let response = error.response;
          console.log(response);
        }
        swal.fire('Hubo un error, intente nuevamente.', 'Error', 'error');
      });
      if(this.fecha_expiracion != null && this.fecha_expiracion != '')
        this.cuentaRegresiva();
    },
    claseNotification: function() {
      let tiempo = this.tiempo_vigencia;
      if(tiempo == null || tiempo == '')
        return 'noti-success';
      if(moment(tiempo, 'HH:mm').isAfter(moment('02:00', 'HH:mm')))
        return 'noti-success';
      else if(moment(tiempo, 'HH:mm').isSameOrBefore(moment('02:00', 'HH:mm')) && moment(tiempo, 'HH:mm').isAfter(moment('01:00', 'HH:mm')))
        return 'noti-warning';
      else
        return 'noti-danger';
    },
    cuentaRegresiva: function(){
      if(this.interval_tiempo_vigencia_id != null && this.interval_tiempo_vigencia_id != ''){
        clearInterval(this.interval_tiempo_vigencia_id);
        this.interval_tiempo_vigencia_id = null;
      }
      let fin = moment(this.fecha_expiracion);
      let inicio = moment(new Date());
      let diferencia = moment(fin.diff(inicio)).format("mm:ss");
      let tiempo = moment('2020-01-01 10:' + diferencia);
      this.interval_tiempo_vigencia_id = setInterval(() => {
        this.tiempo_vigencia = tiempo.milliseconds(-1).format('mm:ss');
        if(this.tiempo_vigencia == '00:00'){
          clearInterval(this.interval_tiempo_vigencia_id);
          this.interval_tiempo_vigencia_id = null;
        }
      }, 1000);
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/codigo-verificacion/CodigoVerificacion.vue